import React, { createContext, useContext, useReducer } from 'react';

const LayoutStateContext: React.Context<{
  isSidebarOpened?: boolean
}> = createContext({});
const LayoutDispatchContext = createContext({});

// -- Reducers -- //
export enum LayoutReducerActions {
  TOGGLE_SIDEBAR
};

function layoutReducer(state, action) {
  switch (action.type) {
    case LayoutReducerActions.TOGGLE_SIDEBAR:
      return { ...state, isSidebarOpened: !state.isSidebarOpened };
    default:
      throw new Error(`Unhandled action type provided ${action.type}`);
  }
}

// -- React Providers -- //
function LayoutProvider({ children }) {
  const [state, dispatch] = useReducer(layoutReducer, {
    isSidebarOpened: true
  });

  return (
    <LayoutStateContext.Provider value={state}>
      <LayoutDispatchContext.Provider value={dispatch}>
        {children}
      </LayoutDispatchContext.Provider>
    </LayoutStateContext.Provider>
  );
}

// -- Context Hooks -- //
function useLayoutState() {
  const context = useContext(LayoutStateContext);
  if (!context) {
    throw new Error('useLayoutState can only be used within a LayoutProvider');
  }

  return context;
}

function useLayoutDispatch() {
  const context = useContext(LayoutDispatchContext);
  if (!context) {
    throw new Error('useLayoutDispatch can only be used within a LayoutProvider');
  }

  return context;
}

// -- Handles -- //
function toggleSidebar(dispatch) {
  dispatch({
    type: LayoutReducerActions.TOGGLE_SIDEBAR
  });
}

export {
  LayoutProvider,
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
};
